import { Dialog } from "@headlessui/react";
import { ModalProp, Modal } from "./Modal"
import { ModalFoterBox } from "../box/Box";
import Button, { BtnProps } from "../button/Button";

export type ModalAndAlmightyDialogProp = {
  toggle: () => void;
  open: boolean;
  title: string;
  children: React.ReactNode;
  actions: BtnProps[];
  height?: string;
}

export const ModalAndAlmightyDialog = ({
  toggle,
  open,
  title,
  children,
  actions,
  height
}: ModalAndAlmightyDialogProp & ModalProp) => {
  return (<>
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={false}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <div className="p-4">
          <div className="text-center">
            <Dialog.Title
              as="h3"
              className="text-left text-lg font-medium leading-6 text-gray-900"
            >
              {title}
            </Dialog.Title>
            <div className="overflow-y-auto mt-4">
              <div className={`text-left h-${height} max-h-[500px]`}>
                {children}
              </div>
            </div>
          </div>
        </div>
        <ModalFoterBox>
          {actions.map((btn,index) => {
            return(
              <Button
                key={`dialogButton${index}`}
                block={btn.block}
                children={btn.children}
                className={`mx-1 ${btn.className}`}
                color={btn.color}
                disabled={btn.disabled}
                outline={btn.outline}
                rounded={btn.rounded}
                size={btn.size}
                submit={btn.submit}
                onClick={btn.onClick}
              />
            )
          })}
        </ModalFoterBox>
      </Dialog.Panel>
    </Modal>
  </>);
}